// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import StopFilledSvg from "@ant-design/icons-svg/es/asn/StopFilled";
import AntdIcon from '../components/AntdIcon';

var StopFilled = function StopFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: StopFilledSvg
  }));
};

StopFilled.displayName = 'StopFilled';
export default /*#__PURE__*/React.forwardRef(StopFilled);